<template>
    <div class="container mt-0 mb-3">
        <div class="row text-center gx-2">
            <div class="col">
                <DBOptionsStat label="Life expectancy" :helpText="htmlArray('dboptions.important-info.life-expectancy.read-more.body')" :value="lifeExpectancy" />
            </div>
            <div class="col" v-if="showPIEStats">
                <DBOptionsStat label="Crossover age" :helpText="textArray('dboptions.modelling.stats.crossover-age.help.body')" :value="crossoverAge" />
            </div>
            <div class="col" v-if="showPIEStats">
                <DBOptionsStat label="Breakeven age" :helpText="textArray('dboptions.modelling.stats.breakeven-age.help.body')" :value="breakevenAge" />
            </div>
            <div class="col">
                <DBOptionsStat label="Average annual increase" :helpText="HelpText.DBOptionsStandardPensionOption()"
                               :value="averageSchemeIncreasesText" subHeading="Standard Pension Option" :showSubHeading="userHasMultipleOptions" />
            </div>
            <div class="col" v-if="showPIEStats">
                <DBOptionsStat label="Average annual increase" :helpText="HelpText.DBOptionsPIE()"
                               :value="averagePIEIncreasesText" subHeading="Pension Increase Exchange" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import HelpText from "@/guiide/ts/helpText";
import DBOptionsStat from "@/guiide/components/dboptions/DBOptionsStat.vue";
import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

const props = defineProps({
    lifeExpectancy: { type: String, required: true },
    breakevenAge: { type: String, required: true },
    crossoverAge: { type: String, required: true },
    averageSchemeIncreases: { type: Number, required: true },
    showPIEStats: { type: Boolean, required: true },
    averagePIEIncreases: { type: Number, required: true },
    selectedOption: { type: Number as PropType<FinalSalaryOption>, required: true },
    userHasMultipleOptions: { type: Boolean, required: true }
});

const { textArray, htmlArray } = useUIContent();

const averageSchemeIncreasesText = computed<string>(() => `${props.averageSchemeIncreases.toFixed(2)}%`);

const showPIEDetails = computed<boolean>(() => props.selectedOption == FinalSalaryOption.PensionIncreaseExchange);

const averagePIEIncreasesText = computed<string>(() => {
    return showPIEDetails.value
        ? `${props.averagePIEIncreases.toFixed(2)}%`
        : "n/a";
});
</script>
